import * as Sentry from '@sentry/react';
import { ConfigProvider } from 'antd';
import { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';

Sentry.init({
   dsn: 'https://462db8cfca9a422d8ccfacd4c265c112@o1185784.ingest.us.sentry.io/6305771',
   enableLogs: true, // Send structured logs to Sentry
   integrations: [
      // send console.log, console.warn, and console.error calls as logs to Sentry
      Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] }),
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
   ],
   replaysOnErrorSampleRate: 1, // Capture Replay for 100% of all errors,
   replaysSessionSampleRate: 0.1, // Capture Replay for 10% of all sessions,
   // oxlint-disable-next-line typescript/no-deprecated
   sendDefaultPii: true, // Send default PII data to Sentry
   tracesSampleRate: 1, // Capture 100% of the transactions
});

const App = lazy(() => import('~/App'));
const element = document.querySelector('#root');

if (!element) {
   throw new Error('Root element not found');
}

ReactDOM.createRoot(element).render(
   <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
      <Suspense fallback="...">
         <ConfigProvider
            theme={{
               token: {
                  // Seed Token
                  colorLink: '#1a9bfc',
                  colorPrimary: '#1a9bfc',
               },
            }}
         >
            <App />
         </ConfigProvider>
      </Suspense>
   </Sentry.ErrorBoundary>,
);
